import {BaseMuWidget} from "../../BaseMuWidget";
import {PqmFieldEmpty} from "./PqmFieldEmpty";
import {Arrays} from "../../Utils";
import {PqmProcData} from "../pqmTypes";

export class BasePqmFieldValue extends BaseMuWidget
{
	public paramType: string = '';
	public control: string = '';
	public numberingId: number|null = null;
	public pqmPacketId: number = -1;

	// @ts-ignore
	public onChange: () => void = () => null;

	static getValueTypes(): string[] { return []; }

	isFilled(): boolean {
		const val = this.getValue();
		if (Array.isArray(val)) return val.length > 0;
		return !!val;
	}

	getValue(): any {
		return this.muFetchData().value;
	}

	setValue(value: any): void {
		this.muBindData({ value });
	}

	value_change() {
		this.onChange();
	}

	async afterSave(res: PqmProcData) {
		return null;
	}

	public setDisabled(disabled: boolean) {
		if (this.ui.value) this.ui.value.disabled = disabled;
		else console.error("Failed sedDisable", this);
	}
}